jQuery(document).ready(function($) {
    var $form = $('.variations_form');

    // On vérifie qu'on est bien en présence d'un formulaire de variations
    if ($form.length === 0) {
        return;
    }

    // 1. CRÉATION DES BOUTONS (SWATCHES)
    $('.variations select').each(function() {
        var $select = $(this);
        var $wrapper = $('<div class="custom-variation-swatches"></div>');
        
        $select.after($wrapper);

        $select.find('option').each(function() {
            var val = $(this).val();
            var text = $(this).text();

            // On ignore l'option vide
            if ( val !== '' ) {
                var $btn = $('<button type="button" class="custom-swatch-btn"></button>');
                $btn.text(text);
                $btn.attr('data-value', val); 
                $wrapper.append($btn);
            }
        });
    });

    // 2. SYNCHRONISATION : Quand le select change, on met à jour les boutons visuellement
    $form.on('change', '.variations select', function() {
        var $select = $(this);
        var currentVal = $select.val();
        var $wrapper = $select.next('.custom-variation-swatches');

        $wrapper.find('.custom-swatch-btn').removeClass('selected');
        
        if ( currentVal && currentVal !== '' ) {
            var safeVal = currentVal.replace(/"/g, '\\"');
            $wrapper.find('.custom-swatch-btn[data-value="' + safeVal + '"]').addClass('selected');
        }
    });

    // 3. ACTION MANUELLE : Quand on clique sur un bouton
    $form.on('click', '.custom-swatch-btn', function(e) {
        e.preventDefault();
        if ( $(this).hasClass('disabled') ) return;

        var $btn = $(this);
        var val = $btn.attr('data-value');
        var $wrapper = $btn.closest('.custom-variation-swatches');
        var $select = $wrapper.prev('select');

        // On change le select caché et on dit à WooCommerce de recalculer
        $select.val(val).trigger('change');
    });

    // 4. PRÉSÉLECTION 100% JAVASCRIPT DE LA MOINS CHÈRE
    // On attend un bref instant pour que le script de WooCommerce soit initialisé
    setTimeout(function() {
        // On récupère le dictionnaire de données JSON natif de WooCommerce
        var variationsData = $form.data('product_variations');

        if (variationsData && variationsData.length > 0) {
            
            // On cherche la variation qui possède le 'display_price' le plus bas
            var cheapestVariation = variationsData.reduce(function(prev, curr) {
                return (prev.display_price < curr.display_price) ? prev : curr;
            });

            // Si on a trouvé la moins chère, on applique ses valeurs aux menus déroulants
            if (cheapestVariation && cheapestVariation.attributes) {
                $.each(cheapestVariation.attributes, function(name, value) {
                    var $select = $form.find('select[name="' + name + '"]');
                    if ($select.length) {
                        // On injecte la valeur et on déclenche l'événement pour afficher le prix
                        $select.val(value).trigger('change');
                    }
                });
            }
        }
    }, 150); // Délai de 150ms pour s'assurer que FlexSlider et WooCommerce sont prêts
});